import { useMutation } from '@tanstack/react-query';
import { adminFetch } from './useAdminApi';

/**
 * usePaperStatement — DocuPost paper-statement preview/send (Phase 2).
 *
 * preview (default): renders + uploads the PDF, returns its public URL. Does
 * NOT spend postage. send: also calls DocuPost + logs to orders.mail_log.
 */

interface MailTo {
  name: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
}

export interface PaperStatementPreview {
  ok: true;
  mode: 'preview';
  pdf_url: string;
  to: MailTo;
  open_count: number;
  open_total: number;
}

export interface PaperStatementSend {
  ok: boolean;
  mode: 'send';
  pdf_url: string;
  docupost: { status: number; raw: string; id: string | null };
  mail_log_id: string | null;
}

export type PaperStatementResult = PaperStatementPreview | PaperStatementSend;

export function usePaperStatement() {
  return useMutation<PaperStatementResult, Error, { customer_id: string; mode: 'preview' | 'send' }>(
    {
      mutationFn: (input) =>
        adminFetch<PaperStatementResult>('admin-send-paper-statement', {
          method: 'POST',
          body: JSON.stringify(input),
        }),
    },
  );
}
